export default __webpack_public_path__ + "static/media/search-icon-light.23489a17.svg";